function handleTabClick(tab, tabs, panels, section) {
  const target = tab.dataset.tabId;

  // Deactivate all tabs and panels
  tabs.forEach(t => {
    t.classList.remove('is-active');
    t.setAttribute('aria-selected', 'false');
  });

  panels.forEach(panel => {
    panel.classList.remove('is-active', 'animate-fadeInUp');
  });

  // Activate the clicked tab
  tab.classList.add('is-active');
  tab.setAttribute('aria-selected', 'true');

  // Activate the corresponding panel and trigger animation
  const activePanel = section.querySelector(`[data-tab-panel="${target}"]`);
  if (activePanel) {
    activePanel.classList.add('is-active');
    
    // Force reflow to replay animation
    activePanel.getBoundingClientRect();
    
    activePanel.classList.add('animate-fadeInUp');
    activePanel.addEventListener('animationend', function onAnimationEnd() {
      activePanel.classList.remove('animate-fadeInUp');
    }, { once: true });
  }
}

function initializeFeaturedCollectionTabs(section) {
  const tabs = section.querySelectorAll('.featured-tabs__tab');
  const panels = section.querySelectorAll('.featured-collection--block');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => handleTabClick(tab, tabs, panels, section));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.featured-collection--root').forEach(initializeFeaturedCollectionTabs);
});